import Sound from '../../shared/ui/Sound/Sound';
import Bar from '../../widgets/Bar/Bar';
import cls from './Game.module.scss';
import ChildrenAnimation from '../../widgets/ChildrenAnimation/ChildrenAnimation';
import { useSelector } from 'react-redux';
import { RootState } from '../../shared/redux/store';
import EndGame from '../../widgets/EndGame/EndGame';
import DraggableAnchor from '../../features/DraggableAnchor/DraggableAnchor';

const Game = () => {
  const endGame = useSelector((state: RootState) => state.pages.endGame);
  const bgImage = useSelector((state: RootState) => state.game.bgImage);
  const anchor = useSelector((state: RootState) => state.hooks.anchor);

  return (
    <div className={cls.Game} style={{ backgroundImage: `url(${bgImage})` }}>
      {!endGame ? (
        <>
          <Sound />
          <Bar />
          <ChildrenAnimation />
          {anchor && <DraggableAnchor />}
        </>
      ) : (
        <EndGame />
      )}
    </div>
  );
};

export default Game;
